<template>
  <div id="template-checkout-view">
    <BookingSummary title="Checkout" step="checkout" />
    <form ref="form" action="/test" method="post" @submit.prevent="getFormValues">
      <GuestDetailsForm
        :errors="$store.state.errors"
        @validate="validateForm"
        :key="`guest-details-${error_key}`"
      />
      <AdditionalGuestsForm />
      <PaymentInformationForm
        :errors="$store.state.errors"
        @validate="validateForm"
        :key="`payment-info-${error_key}`"
      />
      <ExtrasForm v-if="Object.keys($store.state.breakdown.optional_fees).length !== 0" />
      <TermsForm :errors="$store.state.errors" />
      <SubmitForm @validate="validateForm" :key="`submit-${submitting_key}`" />
    </form>
    <ErrorOverlay
      :display_errors="$store.state.display_errors"
      @close="closeErrors()"
      :key="`error-${error_key}`"
    />
  </div>
</template>

<script>
import BookingSummary from './BookingSummary.vue';
import GuestDetailsForm from './GuestDetailsForm.vue';
import AdditionalGuestsForm from './AdditionalGuestsForm.vue';
import PaymentInformationForm from './PaymentInformationForm.vue';
import ExtrasForm from './ExtrasForm.vue';
import TermsForm from './TermsForm.vue';
import SubmitForm from './SubmitForm.vue';
import ErrorOverlay from './ErrorOverlay.vue';
import { mapActions } from 'vuex';
import { serializeFormData } from 'init/forms';

export default {
  components: {
    BookingSummary,
    GuestDetailsForm,
    AdditionalGuestsForm,
    PaymentInformationForm,
    ExtrasForm,
    TermsForm,
    SubmitForm,
    ErrorOverlay,
  },
  data() {
    return {
      valid: true,
      error_key: 0,
      submitting_key: 0
    }
  },
  methods: {
    ...mapActions([
      'submitCheckout'
    ]),
    getFormValues(submitEvent) {
      console.log(submitEvent.target)
    },
    validateForm() {
      let required = this.$refs.form.querySelectorAll('[required]')
      let errorFields = []
      let errors = {}

      this.valid = true

      required.forEach((field) => {
        if (!field.checkValidity()) {
          errors[field.name] = field.validationMessage
          errorFields.push(field)
          this.valid = false
        }
      })

      if (!this.valid) {
        this.$store.commit('displayErrors', { errors: errors, errorFields: errorFields })
        let field = errorFields[0]
        field.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })
        this.error_key += 1
      } else {
        this.$store.commit('clearErrors')
        let formData = serializeFormData(this.$refs.form)
        this.$store.commit('buildReservationRequest', formData)
        this.$store.dispatch('submitCheckout', { parent: this.$parent, component: this })
      }

      return this.valid
    },
    closeErrors() {
      this.$store.commit('dismissErrors')
      this.error_key = 0
    }
  }
}
</script>

<style>
body {
  overflow-x: hidden;
}

#template-checkout-view {
  background: $white;
}

.form-container {
  padding: 20px 28px;
  background: $white;
}

.field-group {
  display: flex;
  flex-flow: column wrap;
  font-size: 16px;
  line-height: 1.38;
  letter-spacing: 0.25px;
  color: #555555;

  &--tablet {
    display: none;
    @mixin breakpoint $tablet {
      display: flex;
    }
  }

  label {
    padding: 20px 0 10px;
  }

  select {
    -webkit-appearance:none;
    -moz-appearance:none;
    background: #fff;
  }

  .select {
    position: relative;
    &:after {
      content: "▼";
      padding: 18px 8px;
      position: absolute;
      right: 10px;
      top: 0;
      z-index: 1;
      text-align: center;
      width: 10%;
      height: 100%;
      pointer-events: none;
      font-size: 11px;
      color: #042f5b;
      box-sizing: border-box;
    }
  }

  input,
  textarea,
  select {
    color: #042f5b;
    padding: 0 16px;
  }

  /*Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  input,
  select {
    height: 50px;
    width: 100%;
  }

  textarea {
    height: 81px;
    padding: 20px;
  }
}

.error-msg {
  position: absolute;
  display: none;
  bottom: -20px;
  left: 0;
  color: red;
  font-size: 12px;
}

.error {
  position: relative;

  input,
  textarea,
  select {
    border: 1px solid red;
  }

  .error-msg {
    display: block;
  }
}

@mixin breakpoint $tablet {
  .form-container {
    padding: 50px;
  }
}

@mixin breakpoint $desktop {
  #template-checkout-view {
    display: flex;
    flex-flow: row-reverse;

    .form-container {
      padding: 70px 50px 50px 50px;
    }

    form {
      width: 100%;
      padding: 0 50px 0 0;
    }
  }
}
</style>
